module.exports = __webpack_public_path__ + "static/interlink-plate-e43fa568038024d115e7ab18d8bc00ea.jpg";